<div class="desktop-header" fxLayoutAlign="start center">
    <img [routerLink]="['/']" routerLinkActive="router-link-active" alt="logo-main" src="assets/logo/logo-casino-white.svg" />
</div>